/* eslint-disable import/prefer-default-export */
import PropTypes from 'prop-types'

export const invoiceListShape = PropTypes.arrayOf(
  PropTypes.shape({
    externalInvoiceId: PropTypes.string.isRequired,
    invoiceNumber: PropTypes.string.isRequired,
    invoiceDate: PropTypes.string.isRequired,
    invoiceAmount: PropTypes.shape({
      amount: PropTypes.string.isRequired,
      currency: PropTypes.string.isRequired,
    }).isRequired,
  })
)
